
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqsYeILjJuSfxxexZusu2CItr9y9P4EZQUVNeShFhBpBEMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/faq.vue?macro=true";
import { default as club49jSlil1xZCTXqHABG_HAOBAhqafy9NdTccpVNqBEuAMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/club.vue?macro=true";
import { default as home9nkJtIMGrjrr4BKTvvj_SFoytI1HEzXm4h9O5fgHkJ0Meta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/home.vue?macro=true";
import { default as about6lqizxETsE7ahaLFdNrLeYfePuEapSn7fXDTwQWiFi0Meta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/about.vue?macro=true";
import { default as indexnjwygb_ZY731O5YroZtfM7j_KgEdohkhed5TQU_KBF4Meta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/index.vue?macro=true";
import { default as termsy_DK2FNJNerAFlwKM8wQTQGKMGszFCQNsqOaU5aMD48Meta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/terms.vue?macro=true";
import { default as latestaZv2Wx3jt6pRJmA6uh6uCaUKEoEnB_vf4ChB2Ja5iNEMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/latest.vue?macro=true";
import { default as searchW7aN0IMF9pnPEkKjn1xMN_awX2CmslM_VDG07PJzD4IMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/search.vue?macro=true";
import { default as _91id_93G5mFaoyhBTBO3KKbllOC4geFda9KJACfNgqQWAq5TSoMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/account/ppv/[id].vue?macro=true";
import { default as indexJIJabnABsr1ZhyXWwPBbEadNYwkwjFonjQ_fKYGYiewMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/account/ppv/index.vue?macro=true";
import { default as ppvRqg6mdsObTRfSjrxy095ji7_z6FNZG6EndYPP7D7F6QMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/account/ppv.vue?macro=true";
import { default as index68IwHX76rPG4I_dgbXlIU2YB5uyf5SmQw6E7pfe742QMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/account/index.vue?macro=true";
import { default as indexbSQcauopYgVSo33bma16KhywAYTysu0VxQKuI52fCRsMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/account/billing/index.vue?macro=true";
import { default as billingylWt87mFVj0nos3UaBNqZI6UKOQlM5NFBjEwpKG_JSIMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/account/billing.vue?macro=true";
import { default as devices70bX5GbSXS8l0yv33qCSJmTj3o7NxwAQQnLDkD_Nr5oMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/account/devices.vue?macro=true";
import { default as general74Oo7U5obWR7hQW79YHLUysr8KFd1YrSbaWCX5a2_qsMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/account/general.vue?macro=true";
import { default as passwordH_L_nTgjwoDEx1nQkEWjRLAkhA31oPVghx6zE0vhF4kMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/account/password.vue?macro=true";
import { default as _91id_930CxVxXDR1m_DMX2RjUkDrsIQ9ulxMqE5ZiQI3gWCgQEMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/account/subscription/[id].vue?macro=true";
import { default as index6WW__AXz7WZIPtoB__ENNQsa5pcczvGmXyzSjJG9VrkMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/account/subscription/index.vue?macro=true";
import { default as _91id_93VXEjCJ7aBRnsSbUyTn46pzjWjUYL8qCbgwK5X46NX9MMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/account/subscription/buy/[id].vue?macro=true";
import { default as subscription72abcagBtQ2VAMwgXDe8GGd2nZDplhf7n5Rnd0DD61MMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/account/subscription.vue?macro=true";
import { default as accountPkQcUawtIr5glthvInWY71FSH5tFnWzs_saZ9sfoQEYMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/account.vue?macro=true";
import { default as archiveLqKCVR526CVfMwBK6zOik4xbgCTOC_OcQcEsiJRFqskMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/archive.vue?macro=true";
import { default as privacyGsCr8lmuPW6UNL0muBXuLb_XuG6fdFECs4rdhvbKCCMMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/privacy.vue?macro=true";
import { default as open_45apptVz5Zr4a2KnBImZXfrgi7MIfG9cc5KaemSbRUpSDUrMMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/open-app.vue?macro=true";
import { default as upcomingAfZS_yCT9OGyLjofGl4vgntKI0kYyiw9Rm3Bjr079h0Meta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/upcoming.vue?macro=true";
import { default as highlightlWF3_nwIYPlujI4rfEyIUrPl_NjcnK0r3_4PR2KegcgMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/highlight.vue?macro=true";
import { default as suggestedJdHhkK3QPbajCsfimS1hWKX1p3_M2nriSH9r_OOwrawMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/suggested.vue?macro=true";
import { default as indexmRtQPNqlmoOTJs8oyaNgTbVXC1CMPocW2krKIir3MI4Meta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/live/index.vue?macro=true";
import { default as dev_45ad_45test8YFQO6aORPOatK_KF3t4mQrMiGhV9hBCsnXDKlFUEnEMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/dev-ad-test.vue?macro=true";
import { default as _91type_93eN1kBunMB59hCk69mP8u5fl23lo_Hg95Uy1eNzPRGBgMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/info/[type].vue?macro=true";
import { default as _91teamId_93ma06teWTpT9mnyp8Bl0lz4k2WWQy4S4tr_AEi8oXCHUMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/team/[teamId].vue?macro=true";
import { default as recommendationxnvqFq35vD1tglnTO0yPSLnfUwSaYgLa_G15wTH0dlUMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/recommendation.vue?macro=true";
import { default as indexBRJ_to6J1nOCmTC2OBO_Up7EWDFCD5xhE92NjuMTF7gMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/following/index.vue?macro=true";
import { default as failurewkSDLC5MYDWHKSyb5LLD4nNCMZE_QJ0X7yNZD_YfrYUMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/payment/failure.vue?macro=true";
import { default as success4hoRNNCqjRLjsGxudZyPl2ySyXPn_cE9z8hlnbPc8W8Meta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/payment/success.vue?macro=true";
import { default as videosKLY_jWVgi41E_QSQEAknJasrcxf2HngCLM5G0qQYg74Meta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/selected/videos.vue?macro=true";
import { default as indexgdXMxBit68hvfrwyu18AeGyAJZs795yk2MLO_3i_lVcMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/auth/login/index.vue?macro=true";
import { default as _91leagueId_93oKIv2p9CcuBJUPkEBOAGuVrkOvv0r7EMQ4_hJDE8qtMMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/league/[leagueId].vue?macro=true";
import { default as _91id_93Y6zqUHeUuMWBDrosz1uxENj_4WbSMfbMudny63zMTM8Meta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/sub-category/[id].vue?macro=true";
import { default as indexlbWCS7Woy1EfE9CGOadQr0gZ1jGnY6jvNzrLL1RbnX4Meta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/auth/sign-up/index.vue?macro=true";
import { default as processing1V9_b3mtKKwooPmYuSe63MMxf31xFZ5LgdLmPmQlrVUMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/payment/processing.vue?macro=true";
import { default as resetdVC1fHy72pTyuwhQ_ynWivV7NABfm41Tpjbk_t6w_00Meta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/auth/password/reset.vue?macro=true";
import { default as highlightsVtWry1F7yOF_NGaz70X9gs0gf_EcomKT0UPrDPD0Vf0Meta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/selected/highlights.vue?macro=true";
import { default as forgotjZ3XTlYFna9WlW4IW1YxFxAYct1CTtrgbEXEJSawl78Meta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/auth/password/forgot.vue?macro=true";
import { default as indexaRiDGuSRt0VTbDNzw1DMdaGVuIp39gpHKE2OmRJMOJEMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/following/teams/index.vue?macro=true";
import { default as indexkMLrJzTtTJ7opcQX2PWCXzj5Z06v2hw1PonMC0ePE8UMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/events/[eventId]/index.vue?macro=true";
import { default as _91eventId_93HE4YmbK1cIC8m5SjXI8eALpLq1aAgtB3hv8cpE_60iUMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/events/stats/[eventId].vue?macro=true";
import { default as indexAkxatBRybc_1ytwg_lBqWZrp4Ym5ckjOYEYaZa5Uqr8Meta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/following/league/index.vue?macro=true";
import { default as indexDssz_K2QBzSTSZIc70jrjvA8iqvgV_ZyjtZoI31BOAoMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/category/[mainId]/index.vue?macro=true";
import { default as indexVgQ1ohbNsRxuN1B1s9JnYkTtCq0QcEYf4G_h4MR9dtsMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/following/category/index.vue?macro=true";
import { default as followed_YkwRP3l0v3lJpPybeHgIZAU7iIUvLM7_imh3cd7wDEMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/following/league/followed.vue?macro=true";
import { default as gameeFlQQmPDzuvCEJXmss5snGF8_5j2nzq6ruVl6MArL18Meta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/events/[eventId]/watch/game.vue?macro=true";
import { default as followed3yxyN5rCAr1NBGyaeaUwYMmrzdyTZQj43uwGwpL1BgcMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/following/category/followed.vue?macro=true";
import { default as indexadfLIrhilI_RFr46pLg7eLRje1dnLeS0kihLcP7Oe1sMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/following/team-roster/index.vue?macro=true";
import { default as personalizationuOBK4EHziNzvHi4_KvnHcOQTqvwVNkaPv9KH_I4MzRcMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/auth/sign-up/personalization.vue?macro=true";
import { default as _91referenceId_93vHHScIcdC2Hwjw7L7ylGl_RrrhhV8kPUr47VX76SBmQMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/redirect/events/[referenceId].vue?macro=true";
import { default as indexbWqEovks_7qAYUe2bxrHqXznIzb1ZE6FRZxJwpA1K2YMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/following/teams/[leagueId]/index.vue?macro=true";
import { default as index6AxA_7Akryj8WOVeqZp40sYBk8lkhOx8jiWI3NTWrsIMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/following/category/[mainId]/index.vue?macro=true";
import { default as indexz1qtgU49Y2lcmSKWWB_BgtdTikplLh_wUY2uJoIWwrMMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/following/league/[leagueId]/index.vue?macro=true";
import { default as index41lLGpZWKfo3GDQgckwGjYWWn7DAeTGsuNt5yoaBFJMMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/auth/sign-up/following/teams/index.vue?macro=true";
import { default as followedqAjLawi6wW3H7soE8ej_YG2FQWC4fdnFie7Qd_5rL2MMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/following/category/[mainId]/followed.vue?macro=true";
import { default as followedHy0clJvliIuttkkVI2ZzNSAD_gSVjbpKqrJV0DDyuSIMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/following/league/[leagueId]/followed.vue?macro=true";
import { default as indexeK6CCRy36HIxFvjrkbfF3VWCUJNgA9oxCJYi_Fmg_CgMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/following/team-roster/[teamId]/index.vue?macro=true";
import { default as followedl_MybvVEnH8rugKep7V8p4YdVmTZcyEsLp5vSSPwpcgMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/auth/sign-up/following/teams/followed.vue?macro=true";
import { default as _91subId_93xyNpND_bsLs3I56wCx0978mT9O9MG_UmNY_FHWH_c1sMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/category/[mainId]/sub-category/[subId].vue?macro=true";
import { default as indexKZYIUn0k5EDPYU1aEsUus6qW0rKl6tFy5GWltmtwy8sMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/auth/sign-up/following/team-roster/index.vue?macro=true";
import { default as followedtdTP_hCWMdCUuNb49aLV2YwoMptyPeiX69F6utLUQLYMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/auth/sign-up/following/team-roster/followed.vue?macro=true";
import { default as indexcuMl0pqDQ0FJ65W74BEJo1CAk8PdhWldIjVBwbefAvcMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/auth/sign-up/following/teams/[leagueId]/index.vue?macro=true";
import { default as indexrBSTFeGPdI_47sDoHQzua7aHbpKu6IysRPxN_da9P_0Meta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/auth/sign-up/following/team-roster/[teamId]/index.vue?macro=true";
import { default as _91gameHighlightId_93_Z29VYVxvW1gxV4wIELIZsU6AK6z92fwlaO4CZv5kuIMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/events/[eventId]/watch/highlight/[gameHighlightId].vue?macro=true";
import { default as _91playerHighlightId_93A3ywW9prkwhHzSQAbosDBmMXqKeXqFmyMZaKT10urWUMeta } from "/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/events/[eventId]/watch/player-highlight/[playerHighlightId].vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    meta: faqsYeILjJuSfxxexZusu2CItr9y9P4EZQUVNeShFhBpBEMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/faq.vue")
  },
  {
    name: "club",
    path: "/club",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/club.vue")
  },
  {
    name: "home",
    path: "/home",
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/home.vue")
  },
  {
    name: "about",
    path: "/about",
    meta: about6lqizxETsE7ahaLFdNrLeYfePuEapSn7fXDTwQWiFi0Meta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/about.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexnjwygb_ZY731O5YroZtfM7j_KgEdohkhed5TQU_KBF4Meta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/index.vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: termsy_DK2FNJNerAFlwKM8wQTQGKMGszFCQNsqOaU5aMD48Meta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/terms.vue")
  },
  {
    name: "latest",
    path: "/latest",
    meta: latestaZv2Wx3jt6pRJmA6uh6uCaUKEoEnB_vf4ChB2Ja5iNEMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/latest.vue")
  },
  {
    name: "search",
    path: "/search",
    meta: searchW7aN0IMF9pnPEkKjn1xMN_awX2CmslM_VDG07PJzD4IMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/search.vue")
  },
  {
    name: accountPkQcUawtIr5glthvInWY71FSH5tFnWzs_saZ9sfoQEYMeta?.name,
    path: "/account",
    meta: { ...(accountPkQcUawtIr5glthvInWY71FSH5tFnWzs_saZ9sfoQEYMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/account.vue"),
    children: [
  {
    name: ppvRqg6mdsObTRfSjrxy095ji7_z6FNZG6EndYPP7D7F6QMeta?.name,
    path: "ppv",
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/account/ppv.vue"),
    children: [
  {
    name: "account-ppv-id",
    path: ":id()",
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/account/ppv/[id].vue")
  },
  {
    name: "account-ppv",
    path: "",
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/account/ppv/index.vue")
  }
]
  },
  {
    name: "account",
    path: "",
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/account/index.vue")
  },
  {
    name: billingylWt87mFVj0nos3UaBNqZI6UKOQlM5NFBjEwpKG_JSIMeta?.name,
    path: "billing",
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/account/billing.vue"),
    children: [
  {
    name: "account-billing",
    path: "",
    meta: { ...(indexbSQcauopYgVSo33bma16KhywAYTysu0VxQKuI52fCRsMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/account/billing/index.vue")
  }
]
  },
  {
    name: "account-devices",
    path: "devices",
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/account/devices.vue")
  },
  {
    name: "account-general",
    path: "general",
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/account/general.vue")
  },
  {
    name: "account-password",
    path: "password",
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/account/password.vue")
  },
  {
    name: subscription72abcagBtQ2VAMwgXDe8GGd2nZDplhf7n5Rnd0DD61MMeta?.name,
    path: "subscription",
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/account/subscription.vue"),
    children: [
  {
    name: "account-subscription-id",
    path: ":id()",
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/account/subscription/[id].vue")
  },
  {
    name: "account-subscription",
    path: "",
    meta: { ...(index6WW__AXz7WZIPtoB__ENNQsa5pcczvGmXyzSjJG9VrkMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/account/subscription/index.vue")
  },
  {
    name: "account-subscription-buy-id",
    path: "buy/:id()",
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/account/subscription/buy/[id].vue")
  }
]
  }
]
  },
  {
    name: "archive",
    path: "/archive",
    meta: archiveLqKCVR526CVfMwBK6zOik4xbgCTOC_OcQcEsiJRFqskMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/archive.vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    meta: privacyGsCr8lmuPW6UNL0muBXuLb_XuG6fdFECs4rdhvbKCCMMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/privacy.vue")
  },
  {
    name: "open-app",
    path: "/open-app",
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/open-app.vue")
  },
  {
    name: "upcoming",
    path: "/upcoming",
    meta: upcomingAfZS_yCT9OGyLjofGl4vgntKI0kYyiw9Rm3Bjr079h0Meta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/upcoming.vue")
  },
  {
    name: "highlight",
    path: "/highlight",
    meta: highlightlWF3_nwIYPlujI4rfEyIUrPl_NjcnK0r3_4PR2KegcgMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/highlight.vue")
  },
  {
    name: "suggested",
    path: "/suggested",
    meta: suggestedJdHhkK3QPbajCsfimS1hWKX1p3_M2nriSH9r_OOwrawMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/suggested.vue")
  },
  {
    name: "live",
    path: "/live",
    meta: indexmRtQPNqlmoOTJs8oyaNgTbVXC1CMPocW2krKIir3MI4Meta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/live/index.vue")
  },
  {
    name: "dev-ad-test",
    path: "/dev-ad-test",
    meta: dev_45ad_45test8YFQO6aORPOatK_KF3t4mQrMiGhV9hBCsnXDKlFUEnEMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/dev-ad-test.vue")
  },
  {
    name: "info-type",
    path: "/info/:type()",
    meta: _91type_93eN1kBunMB59hCk69mP8u5fl23lo_Hg95Uy1eNzPRGBgMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/info/[type].vue")
  },
  {
    name: "team-teamId",
    path: "/team/:teamId()",
    meta: _91teamId_93ma06teWTpT9mnyp8Bl0lz4k2WWQy4S4tr_AEi8oXCHUMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/team/[teamId].vue")
  },
  {
    name: "recommendation",
    path: "/recommendation",
    meta: { ...(recommendationxnvqFq35vD1tglnTO0yPSLnfUwSaYgLa_G15wTH0dlUMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/recommendation.vue")
  },
  {
    name: "following",
    path: "/following",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/following/index.vue")
  },
  {
    name: "payment-failure",
    path: "/payment/failure",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/payment/failure.vue")
  },
  {
    name: "payment-success",
    path: "/payment/success",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/payment/success.vue")
  },
  {
    name: "selected-videos",
    path: "/selected/videos",
    meta: { ...(videosKLY_jWVgi41E_QSQEAknJasrcxf2HngCLM5G0qQYg74Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/selected/videos.vue")
  },
  {
    name: "auth-login",
    path: "/auth/login",
    meta: indexgdXMxBit68hvfrwyu18AeGyAJZs795yk2MLO_3i_lVcMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/auth/login/index.vue")
  },
  {
    name: "league-leagueId",
    path: "/league/:leagueId()",
    meta: _91leagueId_93oKIv2p9CcuBJUPkEBOAGuVrkOvv0r7EMQ4_hJDE8qtMMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/league/[leagueId].vue")
  },
  {
    name: "sub-category-id",
    path: "/sub-category/:id()",
    meta: _91id_93Y6zqUHeUuMWBDrosz1uxENj_4WbSMfbMudny63zMTM8Meta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/sub-category/[id].vue")
  },
  {
    name: "auth-sign-up",
    path: "/auth/sign-up",
    meta: indexlbWCS7Woy1EfE9CGOadQr0gZ1jGnY6jvNzrLL1RbnX4Meta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/auth/sign-up/index.vue")
  },
  {
    name: "payment-processing",
    path: "/payment/processing",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/payment/processing.vue")
  },
  {
    name: "auth-password-reset",
    path: "/auth/password/reset",
    meta: resetdVC1fHy72pTyuwhQ_ynWivV7NABfm41Tpjbk_t6w_00Meta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/auth/password/reset.vue")
  },
  {
    name: "selected-highlights",
    path: "/selected/highlights",
    meta: { ...(highlightsVtWry1F7yOF_NGaz70X9gs0gf_EcomKT0UPrDPD0Vf0Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/selected/highlights.vue")
  },
  {
    name: "auth-password-forgot",
    path: "/auth/password/forgot",
    meta: forgotjZ3XTlYFna9WlW4IW1YxFxAYct1CTtrgbEXEJSawl78Meta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/auth/password/forgot.vue")
  },
  {
    name: "following-teams",
    path: "/following/teams",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/following/teams/index.vue")
  },
  {
    name: "events-eventId",
    path: "/events/:eventId()",
    meta: indexkMLrJzTtTJ7opcQX2PWCXzj5Z06v2hw1PonMC0ePE8UMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/events/[eventId]/index.vue")
  },
  {
    name: "events-stats-eventId",
    path: "/events/stats/:eventId()",
    meta: _91eventId_93HE4YmbK1cIC8m5SjXI8eALpLq1aAgtB3hv8cpE_60iUMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/events/stats/[eventId].vue")
  },
  {
    name: "following-league",
    path: "/following/league",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/following/league/index.vue")
  },
  {
    name: "category-mainId",
    path: "/category/:mainId()",
    meta: indexDssz_K2QBzSTSZIc70jrjvA8iqvgV_ZyjtZoI31BOAoMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/category/[mainId]/index.vue")
  },
  {
    name: "following-category",
    path: "/following/category",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/following/category/index.vue")
  },
  {
    name: "following-league-followed",
    path: "/following/league/followed",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/following/league/followed.vue")
  },
  {
    name: "events-eventId-watch-game",
    path: "/events/:eventId()/watch/game",
    meta: gameeFlQQmPDzuvCEJXmss5snGF8_5j2nzq6ruVl6MArL18Meta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/events/[eventId]/watch/game.vue")
  },
  {
    name: "following-category-followed",
    path: "/following/category/followed",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/following/category/followed.vue")
  },
  {
    name: "following-team-roster",
    path: "/following/team-roster",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/following/team-roster/index.vue")
  },
  {
    name: "auth-sign-up-personalization",
    path: "/auth/sign-up/personalization",
    meta: { ...(personalizationuOBK4EHziNzvHi4_KvnHcOQTqvwVNkaPv9KH_I4MzRcMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/auth/sign-up/personalization.vue")
  },
  {
    name: "redirect-events-referenceId",
    path: "/redirect/events/:referenceId()",
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/redirect/events/[referenceId].vue")
  },
  {
    name: "following-teams-leagueId",
    path: "/following/teams/:leagueId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/following/teams/[leagueId]/index.vue")
  },
  {
    name: "following-category-mainId",
    path: "/following/category/:mainId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/following/category/[mainId]/index.vue")
  },
  {
    name: "following-league-leagueId",
    path: "/following/league/:leagueId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/following/league/[leagueId]/index.vue")
  },
  {
    name: "auth-sign-up-following-teams",
    path: "/auth/sign-up/following/teams",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/auth/sign-up/following/teams/index.vue")
  },
  {
    name: "following-category-mainId-followed",
    path: "/following/category/:mainId()/followed",
    meta: { ...(followedqAjLawi6wW3H7soE8ej_YG2FQWC4fdnFie7Qd_5rL2MMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/following/category/[mainId]/followed.vue")
  },
  {
    name: "following-league-leagueId-followed",
    path: "/following/league/:leagueId()/followed",
    meta: { ...(followedHy0clJvliIuttkkVI2ZzNSAD_gSVjbpKqrJV0DDyuSIMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/following/league/[leagueId]/followed.vue")
  },
  {
    name: "following-team-roster-teamId",
    path: "/following/team-roster/:teamId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/following/team-roster/[teamId]/index.vue")
  },
  {
    name: "auth-sign-up-following-teams-followed",
    path: "/auth/sign-up/following/teams/followed",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/auth/sign-up/following/teams/followed.vue")
  },
  {
    name: "category-mainId-sub-category-subId",
    path: "/category/:mainId()/sub-category/:subId()",
    meta: _91subId_93xyNpND_bsLs3I56wCx0978mT9O9MG_UmNY_FHWH_c1sMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/app/pages/category/[mainId]/sub-category/[subId].vue")
  },
  {
    name: "auth-sign-up-following-team-roster",
    path: "/auth/sign-up/following/team-roster",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/auth/sign-up/following/team-roster/index.vue")
  },
  {
    name: "auth-sign-up-following-team-roster-followed",
    path: "/auth/sign-up/following/team-roster/followed",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/auth/sign-up/following/team-roster/followed.vue")
  },
  {
    name: "auth-sign-up-following-teams-leagueId",
    path: "/auth/sign-up/following/teams/:leagueId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/auth/sign-up/following/teams/[leagueId]/index.vue")
  },
  {
    name: "auth-sign-up-following-team-roster-teamId",
    path: "/auth/sign-up/following/team-roster/:teamId()",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/auth/sign-up/following/team-roster/[teamId]/index.vue")
  },
  {
    name: "events-eventId-watch-highlight-gameHighlightId",
    path: "/events/:eventId()/watch/highlight/:gameHighlightId()",
    meta: _91gameHighlightId_93_Z29VYVxvW1gxV4wIELIZsU6AK6z92fwlaO4CZv5kuIMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/events/[eventId]/watch/highlight/[gameHighlightId].vue")
  },
  {
    name: "events-eventId-watch-player-highlight-playerHighlightId",
    path: "/events/:eventId()/watch/player-highlight/:playerHighlightId()",
    meta: _91playerHighlightId_93A3ywW9prkwhHzSQAbosDBmMXqKeXqFmyMZaKT10urWUMeta || {},
    component: () => import("/home/runner/work/ott-web-portal2/ott-web-portal2/apps/modern/app/pages/events/[eventId]/watch/player-highlight/[playerHighlightId].vue")
  }
]